exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/files/components/files-table-data/files-table-data.component.scss
// module id = ../../../../../src/app/files/components/files-table-data/files-table-data.component.scss
// module chunks = main